module.exports = __webpack_public_path__ + "static/media/trash.f40c170a.svg";